<template>
    <div class="caz-banner">
        <BannerImage :image="images" />

        <div class="container">
            <div class="caz-overlay">
                <h1 class="caz-title">{{ heading }}</h1>

                <div class="form-group">
                    <input
                        name="location"
                        type="text"
                        placeholder="Enter Location"
                        class="form-control form-control--text"
                        ref="locationInput"
                    />
                </div>

                <div class="bg-danger animated slideInDown caz-error" v-if="error">
                    Please enter a valid location
                </div>

                <button class="btn btn--primary btn--full-width" v-on:click="check">
                    Check Location
                </button>

                <div
                    class="trustpilot-widget caz__tp-widget"
                    data-locale="en-GB"
                    data-template-id="5419b732fbfb950b10de65e5"
                    data-businessunit-id="55a4b2750000ff00058109a4"
                    data-style-height="24px"
                    data-style-width="100%"
                    data-theme="dark"
                    ref="trustpilot"
                >
                    <a
                        href="https://uk.trustpilot.com/review/www.robinsandday.co.uk"
                        target="_blank"
                        rel="noopener"
                        >Trustpilot</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BannerImage from "../BannerImage.vue";
import { customEvent } from "../../../../modules/tracking/AnalyticsEvents";

export default {
    components: { BannerImage },
    data() {
        return {
            error: false,
            googleClass: null,
            autocomplete: null,
        };
    },
    computed: {
        ...mapState(["images", "heading"]),
        ...mapGetters(["currentStep"]),
        place: {
            get() {
                return this.$store.state.place;
            },
            set(value) {
                this.$store.commit("setPlace", value);
            },
        },
    },
    methods: {
        check() {
            if (this.error || !this.place) {
                this.error = true;
                return;
            }
            customEvent({
                category: "Clean Air Zone",
                label: "Check Location",
                action: "Clicked",
            });
            this.error = false;
            this.$store.dispatch("navigatorStep", this.currentStep.next);
        },
    },
    mounted() {
        const input = this.$refs.locationInput;

        window.GoogleMapsLoader.getMap().then((google) => {
            this.googleClass = google;

            this.autocomplete = new google.maps.places.Autocomplete(input);
            this.autocomplete.setComponentRestrictions({
                country: ["gb"],
            });
            this.autocomplete.setFields([
                "formatted_address",
                "geometry",
                "place_id",
                "address_component",
            ]);

            this.autocomplete.addListener("place_changed", () => {
                const place = this.autocomplete.getPlace();

                if (!place || !place.geometry) {
                    this.error = true;
                    return;
                }

                this.error = false;
                this.place = place;
                this.$store.commit("setLocation", {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                });
            });
        });
    },
    beforeDestroy() {
        this.googleClass.maps.event.clearInstanceListeners(this.autocomplete);
        this.autocomplete.unbindAll();
    },
};
</script>

<style lang="scss" scoped>
.caz {
    &-banner {
        position: relative;
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column-reverse;
    }

    @media (min-width: 768px) {
        &-banner {
            height: 450px;
        }
    }

    &-overlay {
        background: linear-gradient(0deg, #0b1e3a 0%, #0293d6 100%);
        box-shadow: 0px 11px 24px rgba(0, 0, 0, 0.07);
        width: 100%;
        max-width: 350px;
        max-width: 100%;
        padding: 15px 30px 30px 30px;
        border-radius: 0 0 10px 10px;
    }

    @media (min-width: 768px) {
        &-overlay {
            padding: 40px 30px 30px 30px;
            border-radius: 10px;
            position: absolute;
            top: 60px;
            max-width: 345px;
        }
    }

    &-title {
        font-weight: 700;
        margin: 0;
        color: white;
        font-size: 20px;
        line-height: 20px;
        text-align: center;
        width: 100%;
        margin-bottom: 26px;
        display: inline-block;
    }

    &-error {
        margin-top: -8px;
        margin-bottom: 15px;
        padding: 7px;
        background-color: red;
        border-radius: 4px;
        color: white;
        font-size: 14px;
        font-weight: bold;
        animation-duration: 0.3s;
        animation-fill-mode: both;
    }

    &__tp-widget {
        margin-top: 28px;
        margin-bottom: 5px;
    }
}
</style>
